import { render, staticRenderFns } from "./template-3.vue?vue&type=template&id=1e2592c8&scoped=true"
import script from "./template-3.vue?vue&type=script&lang=js"
export * from "./template-3.vue?vue&type=script&lang=js"
import style0 from "./template-3.vue?vue&type=style&index=0&id=1e2592c8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e2592c8",
  null
  
)

export default component.exports